import { PublicClientApplication } from "@azure/msal-browser";

/**
 * MSAL (Microsoft Authentication Library) configuration for Azure AD authentication.
 * Uses environment variables to keep sensitive information secure and allow easy configuration.
 * 
 * - `clientId`: The Application (client) ID from Azure AD.
 * - `authority`: The Azure AD authority URL (tenant-specific or common).
 * - `redirectUri`: The URL where users are redirected after login.
 * - `cacheLocation`: Stores tokens in sessionStorage for security and lifecycle control.
 * - `storeAuthStateInCookie`: Disabled here to avoid storing auth state in cookies.
 */
const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,       // Azure AD Application (client) ID from env
    authority: process.env.REACT_APP_AUTHORITY,      // Azure AD tenant or common authority URL
    redirectUri: process.env.REACT_APP_REDIRECT_URI, // URI where users are redirected post-login
  },
  cache: {
    cacheLocation: "sessionStorage",                 // Store tokens in sessionStorage (cleared on tab close)
    storeAuthStateInCookie: false,                   // Do not store auth state in cookies to avoid certain browser issues
  },
};

/**
 * Create an MSAL PublicClientApplication instance using the above configuration.
 * This instance manages authentication flows (login, token acquisition) throughout the app.
 */
export const msalInstance = new PublicClientApplication(msalConfig);

/**
 * Initialize the MSAL instance to ensure all setup is complete before usage.
 * Important for MSAL v3+ to prevent potential race conditions or initialization issues.
 */
await msalInstance.initialize();
